module.exports = __webpack_public_path__ + "img/Jump Casting29.4722ace9.jpg";